'use strict';

var React = require('react');

var AriaMenuButtonManagerContext = React.createContext();

module.exports = AriaMenuButtonManagerContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-aria-menubutton/dist/ManagerContext.js
// module id = 54
// module chunks = 0